import type { FC } from "react";
import { useAutocomplete } from "../../providers/AutocompleteProvider";
import {useConfigContext} from "../../../ConfigProvider.tsx";

export const CategoryMatches: FC = () => {
    const { hits, autocompleteState } = useAutocomplete();
    const {
        tc,
        algoliaConfig: { customizedUrl },
    } = useConfigContext();

    const query = autocompleteState.query?.trim();
    if (!query) return null;

    type Lvl2 = { slug: string; name: string };

    const lvl2s = hits
        .map((hit) => {
            const hc = (hit as any).hierarchicalCategories;
            if (!Array.isArray(hc)) return null;
            const entry = hc.find((o: any) => o.lvl2 && o.lvl2.slug);
            return entry?.lvl2 as Lvl2 | null;
        })
        .filter((c): c is Lvl2 => !!c?.slug);

    const unique = lvl2s.filter(
        (cat, idx, self) => self.findIndex((c) => c.slug === cat.slug) === idx
    );

    if (unique.length === 0) return null;

    return (
        <>
            <div className="resultHeadline">
                {tc.categories} ({unique.length})
            </div>
            <ul className="categoryMatches">
                {unique.map(({ slug, name }) => {
                    const href = `/${customizedUrl}/${encodeURIComponent(
                        slug
                    )}/?input_search=${encodeURIComponent(query)}`;
                    return (
                        <li key={slug}>
                            <a href={href}>
                                <strong>{query}</strong> in {name}
                            </a>
                        </li>
                    );
                })}
            </ul>
        </>
    );
};
